import * as React from 'react';
import cx from 'classnames';

import Text from 'components/Text';

import './styles/TextBadge.scss';

type TextBadgeColor = 'lava' | 'shamrock' | 'wolf' | 'polar-bear' | 'eclipse' | 'sunrise';
type TextBadgeTextColor = 'white' | 'thunder' | 'pitch' | 'lava' | 'flame';

type Props = {
  children: React.ReactChildren;
};

type DefaultProps = {
  color: TextBadgeColor;
  textSize: 'xsmall' | 'xxxxsmall';
  textColor: TextBadgeTextColor;
  textWeight: 'normal' | 'semibold';
};

class TextBadge extends React.Component<Props & DefaultProps> {
  static defaultProps: DefaultProps = {
    color: 'polar-bear',
    textColor: 'thunder',
    textWeight: 'semibold',
    textSize: 'xsmall',
  };

  render() {
    const { color, textColor, textWeight, textSize, children } = this.props;

    return (
      <Text
        color={textColor}
        weight={textWeight}
        size={textSize}
        className={cx('TextBadge', `TextBadge--${color}`, `TextBadge--${textSize}`)}
        element="div">
        {children}
      </Text>
    );
  }
}

export default TextBadge;
